<template>
  <div id="intro-page">
    <div class="intro-page-container">
      <div class="main-copy-area background">
        <h2 class="blind">온라인 가입신청서 작성 초기화면</h2>
        <p class="flex">
          <span class="lg-u-plus">LG U<sup>+</sup></span
          ><span class="title">공식 온라인 가입채널에</span>
        </p>
        <p class="welcome-message">오신것을 환영합니다.</p>

        <div class="separator-small" />

        <div class="column-layout intro-copy">
          <p>
            새로운 가입신청서를 작성하시려면
            <strong>'신청서 신규 작성'</strong> 버튼을 클릭해주세요.
          </p>
        </div>

        <div class="separator-small" />

        <div class="intro-selection">
          <div class="button-container">
            <button
              type="button"
              :disabled="$store.state.notFoundUrl"
              :class="{ disabled: $store.state.notFoundUrl }"
              class="new-registration ml0"
              @click="goToRegistrationStep1"
            >
              신청서 신규 작성
            </button>
            <!-- <button type='button' class='in-progress-registration' @click='goToExistingRegistration'>진행중 신청서</button>         -->
          </div>
        </div>
      </div>
    </div>
    <div class="column-layout main-sub-area">
      <p class="text-info-title">신청서 작성 전 준비사항</p>

      <ul class="notice-text-list">
        <li class="notice-text">
          저희 LG U+는 고객의 개인정보보호 및 편리한 가입을 위해
          전자서명(공인인증서) 및 신용카드 인증을 통한 가입 시스템을 지원하고
          있습니다.
        </li>
        <li class="notice-text">
          온라인 가입채널 이용을 위해서는 가입 희망 고객(명의자)님의
          공인인증서나 가입자 본인 명의 신용카드(청소년 가입자는 법정 대리인
          명의)를 미리 준비해주시기 바랍니다.
        </li>
        <li class="notice-text">
          <div class="bold-text">전자상거래법 제5조 2항에 의거</div>
          <div>
            본 가입신청서 상에서 고객님의 공인인증서는 고객님 본인의 서명,
            서명날인 또는 기념날인으로 본 가입신청서에 전자서명된 이후 그 내용이
            변경되지 않는 것으로 다루어집니다.
          </div>
        </li>
      </ul>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import { getOpenMarketInfo } from '@/api/openmarket'
import { getSamSungInfo } from '@/api/openmarket'

export default {
  name: 'IntroPage',
  data() {
    return {
      opmkNo: '',
      agentId: '',
      formId: '',
      result: {},
      alertMsg: '',
      data: {
        agentId: '',
        agentName: '',
        sbgnPosNm: '',
        sbgnPosCd: ''
      }
    }
  },
  components: {},
  computed: {
    // agent() {
    //  return this.$store.state.openMarketInfo
    // }
  },
  beforeCreate() {
    // this.showOpenMarketInfo()
  },

  created() {},
  mounted() {
    let params = this.getUrlParams()
    // 오픈마켓 정보 저장
    if(params.formId==='2487500' || params.formId==='2487501' || params.formId==='2487502' || params.formId==='2487503'){
      if(!params.agentId || !params.formId || !params.openmktCd || !params.trmMdlCd || !params.ppCd) {
          this.openAlert(
            '온라인 가입신청 안내',
            '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
          )
          return
      }
    }else{
      if(!params.agentId || !params.formId || !params.openmktCd ) {
          this.openAlert(
            '온라인 가입신청 안내',
            '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
          )
          return
      }
    }
    //samsung
    if(params.formId==='2487500' || params.formId==='2487501' || params.formId==='2487502' || params.formId==='2487503'){
      getSamSungInfo(params.agentId, params.formId, params.openmktCd, params.trmMdlCd, params.ppCd)
        .then(res => {
          let response = res.data
          response.agentId = params.agentId
          response.dealCd = params.agentId
          response.formId = params.formId
          response.entrRqstFomNo = params.formId
          response.openMarketCode = params.openmktCd
          if (response.resCode === 'FAIL') {
            this.$store.state.notFoundUrl = true
            this.openAlert('온라인 가입신청 안내', response.resMsg)
          } else {
            this.$store.state.samsung.trmMdlCd = params.trmMdlCd
            this.$store.state.samsung.trmMdlNm = response.inTrmMdlNm
            this.$store.state.samsung.esimTrmYn = response.inEsimYn
            this.$store.state.samsung.ppCd = params.ppCd
            this.$store.state.samsung.ppNm = response.inPpNm
            this.$store.state.samsung.usimYn = params.usimYn
            this.$store.state.samsung.dcntKdCd = params.dcntKdCd         
            this.$store.state.notFoundUrl = false
            this.$store.commit('saveOpenMarketInfo', response)
            this.showOpenMarketInfo()
          }
          this.goToRegistrationStep1()
        })
        .catch(error => {
          this.$store.state.notFoundUrl = true
          this.openAlert(
            '온라인 가입신청 안내',
            '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
          )
        })  
    }else{
      getOpenMarketInfo(params.agentId, params.formId, params.openmktCd)
        .then(res => {
          let response = res.data
          response.agentId = params.agentId
          response.dealCd = params.agentId
          response.formId = params.formId
          response.entrRqstFomNo = params.formId
          response.openMarketCode = params.openmktCd
          if (response.resCode === 'FAIL') {
            this.$store.state.notFoundUrl = true
            this.openAlert('온라인 가입신청 안내', response.resMsg)
          } else {
            this.$store.state.notFoundUrl = false
            this.$store.commit('saveOpenMarketInfo', response)
            this.showOpenMarketInfo()
          }
          this.goToRegistrationStep1()
        })
        .catch(error => {
          this.$store.state.notFoundUrl = true
          this.openAlert(
            '온라인 가입신청 안내',
            '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
          )
        })
    }
  },

  methods: {
    /** 
     * Function    : getUrlParams
     * Description : 임시저장에서 이메일로 들어온 경우
     **/
    getUrlParams() {
      var params = {}
      window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
        str,
        key,
        value
      ) {
        params[key] = value
      })
      return params
    },

    /** 
     * Function    : goToRegistrationStep1
     * Description : 신규 신청서 작성
     **/
    goToRegistrationStep1() {
      this.$router.push({ name: 'RegistrationStep1_samsung' })
    },

    /** 
     * Function    : goToExistingRegistration
     * Description : 진행중인 신청서
     **/
    goToExistingRegistration() {
      this.$router.push({ name: 'ExistingRegistration_samsung' })
    },

    /** 
     * Function    : showOpenMarketInfo
     * Description : 처음 진입시 오픈마켓 정보 팝업
     **/
    showOpenMarketInfo() {
      let title = '온라인 가입신청 안내'
      let message = ''
      if (
        '900567' !== this.$store.state.openMarketInfo.dealCd &&
        null !== this.$store.state.openMarketInfo.agentName &&
        '' !== this.$store.state.openMarketInfo.agentName
      ) {
        if (
          this.$store.state.openMarketInfo.sbgnPosCd !== '' &&
          this.$store.state.openMarketInfo.sbgnPosCd !== null
        ) {
          //유치 POS 정보가 있는 경우는 pos code 를 보여준다. C20181018_20522_3820522
          message =
            '고객님은 LG유플러스의 대리점인\n' +
            this.$store.state.openMarketInfo.agentName +
            '\n(대리점코드[' +
            this.$store.state.openMarketInfo.dealCd +
            '] - [' +
            this.$store.state.openMarketInfo.sbgnPosNm +
            '][' +
            this.$store.state.openMarketInfo.sbgnPosCd +
            '])\n를 통해 가입이 됩니다.'
        } else {
          message =
            '고객님은 LG유플러스의 대리점인\n' +
            this.$store.state.openMarketInfo.agentName +
            '\n(대리점코드[' +
            this.$store.state.openMarketInfo.dealCd +
            '])\n를 통해 가입이 됩니다.'
        }
        this.openAlert(title, message)
      }
    },

    /** 
     * Function    : openAlert
     * Description : 최종저장까지 하는 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
